import gql from 'graphql-tag';

export default gql`
  mutation updateDraftInteraction($contentId: UUID!, $interaction: JSON!) {
    me {
      updateDraftInteraction(contentId: $contentId, interaction: $interaction)
    }
  }
`;
